import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  UntypedFormGroup, ValidationErrors,
  Validators
} from "@angular/forms";
import {SharedService} from "../../../../shared/shared.service";
import {CoreService} from "../../../../../services/core/core.service";
import {JobDataService} from "../../../job/job.data.service";
import {MatTreeFlatDataSource} from "@angular/material/tree";
import {first, pairwise, startWith} from "rxjs/operators";
import {Subscription} from "rxjs";
import { NotOnlySpaces } from '../../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import {AppConstants} from "../../../../../constants/app.constants";

@Component({
    selector: 'app-add-change-order',
    templateUrl: './add-change-order.component.html',
    styleUrls: ['./add-change-order.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AddChangeOrderComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AddChangeOrderComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AddChangeOrderComponent implements OnInit {
  // @ts-ignore
  @ViewChild(AddChangeOrderComponent,{static: true}) AddChangeOrderComponent: AddChangeOrderComponent;
  @Input() form: any = {};
  @Input() model: any = {};
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  public orderTypeList :any=[ ];
  // @ts-ignore
  private changeOrderSubscription: Subscription;
  selectedCategoryType = 0;
  selectedCategoryId = '';
  selectedCategoryItems: any = [];
  searchServiceParams = {
    jobId: '',
    search: ''
  };
  public changeOrder: UntypedFormGroup = this.initFormChangeOrder();
  constructor(
    public JobDataService: JobDataService,
    public sharedService: SharedService,
    public coreService: CoreService
  ) {
    this.orderTypeList =  AppConstants.changeOrderTypes;

  }

  ngOnInit(): void {
    this.initSubscriptions();
  }
  ngOnChanges(changes: SimpleChanges) {
  }
  initFormChangeOrder(value: any = null){
    return new UntypedFormGroup({
      jobName:new UntypedFormControl(value?.jobName,[]),
      orderType: new UntypedFormControl(value?.orderType,[Validators.required]),
      job_id: new UntypedFormControl(value?.job_id,[Validators.required]),
    });
    this.onInitForm.emit(this.changeOrder);
    return this.changeOrder;
  }
  initForm(value: any = null){
    this.changeOrder = this.initFormChangeOrder(value);
    this.onInitForm.emit( this.changeOrder);
  }
  selectedJobValueChange(event: any) {
    this.changeOrder.get('job_id')?.setValue(event ? event.id : null);
    this.changeOrder.get('jobName')?.setValue(event ? event.name : null);
  }
  attachCategoryItem(value: any){
    console.log('value',value);
    const data = {
      item_type: this.selectedCategoryType,
      category_idfk: this.selectedCategoryId,
      item_id: value?.id,
    }
    console.log(data);
    this.JobDataService.list(data)
      .pipe(first())
      .subscribe(
        data => {
          this.addCreatedItemToList(value);
          this.callback.emit(true);
        });
  }
  addCreatedItemToList(part: any, type= 'part'){
    this.selectedCategoryItems.push(part);
  }
  initSubscriptions(){
    // @ts-ignore
    // this.task.get('name').updateValueAndValidity({ onlySelf: false, emitEvent: true });

    this.changeOrderSubscription = this.form.valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        if (this.form.touched){
          this.touchFormControls();
        }
      });
  }
  touchFormControls(){
    Object.keys(this.changeOrder.controls).forEach(key => {
      this.changeOrder.get(key)?.markAsTouched();
    });
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.changeOrderSubscription.unsubscribe();
  }
  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.changeOrder.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.changeOrder.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.changeOrder.disable() : this.changeOrder.enable();
  }
  validate(c: AbstractControl): ValidationErrors | null{
    return this.changeOrder.valid ? null : { invalidForm: {valid: false, message: "task  fields are invalid"}};
  }
}
